import React from "react";
import { Input } from "../ui/input";

export const PRESETS = [
  { key: "today", label: "Today" },
  { key: "week", label: "This week" },
  { key: "month", label: "This month" },
  { key: "last_month", label: "Last month" },
  { key: "last_3_months", label: "Last 3 months" },
];

export const TYPES = [
  { key: "all", label: "All" },
  { key: "ride", label: "Rides" },
  { key: "food", label: "Food deliveries" },
  { key: "goods", label: "Goods delivery" },
];

// Build backend query params from the filter value.
export function toParams(v) {
  const params = {};
  if (v.from || v.to) {
    if (v.from) params.from = v.from;
    if (v.to) params.to = v.to;
  } else {
    params.preset = v.preset || "month";
  }
  if (v.type && v.type !== "all") params.type = v.type;
  return params;
}

export const defaultFilter = { preset: "month", from: "", to: "", type: "all" };

export default function ReportFilters({ value, onChange, showType = false }) {
  const setPreset = (preset) => onChange({ ...value, preset, from: "", to: "" });
  const setDate = (k, val) => onChange({ ...value, [k]: val, preset: "" });
  const custom = !!(value.from || value.to);

  return (
    <div className="mb-6 space-y-3" data-testid="report-filters">
      <div className="flex flex-wrap gap-2" data-testid="report-presets">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            onClick={() => setPreset(p.key)}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${!custom && value.preset === p.key ? "bg-ink text-surface" : "bg-white text-ink-soft ring-1 ring-surface-300 hover:text-ink"}`}
            data-testid={`preset-${p.key}`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex items-end gap-2">
          <label className="text-xs text-ink-muted">From
            <Input type="date" value={value.from} max={value.to || undefined} onChange={(e) => setDate("from", e.target.value)} className="mt-1 w-40" data-testid="filter-from" />
          </label>
          <label className="text-xs text-ink-muted">To
            <Input type="date" value={value.to} min={value.from || undefined} onChange={(e) => setDate("to", e.target.value)} className="mt-1 w-40" data-testid="filter-to" />
          </label>
          {custom && (
            <button onClick={() => onChange({ ...value, from: "", to: "", preset: "month" })} className="pb-2 text-xs font-medium text-brand hover:underline" data-testid="filter-clear-dates">Clear</button>
          )}
        </div>
        {showType && (
          <div className="flex gap-2" data-testid="report-types">
            {TYPES.map((t) => (
              <button
                key={t.key}
                onClick={() => onChange({ ...value, type: t.key })}
                className={`rounded-full px-3 py-2 text-xs font-medium transition-colors ${value.type === t.key ? "bg-brand text-white" : "bg-white text-ink-soft ring-1 ring-surface-300 hover:text-ink"}`}
                data-testid={`type-${t.key}`}
              >
                {t.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
